import { Component, Input } from '@angular/core';
import { DsChipColorVariant, Icons } from '@levelaccess/design-system';
import { ScanViewportType } from '../../../../shared/constants/scan-viewport';
import { IScanViewport } from '../../../../shared/interfaces/scan-viewport.interface';
import { SharedCommonUtility } from '../../../../shared/utils/common.utility';
import { TranslateService } from '../../translate/translate.service';

const ViewportIconsMap: Partial<Record<ScanViewportType, Icons>> = {
  [ScanViewportType.desktop]: Icons.Desktop,
  [ScanViewportType.mobile]: Icons.Mobile,
  [ScanViewportType.tablet]: Icons.Tablet,
};

@Component({
  selector: 'app-viewport-inline',
  templateUrl: './viewport-inline.component.html',
  standalone: false,
})
export class ViewportInlineComponent {
  @Input() public scanViewport: IScanViewport;
  @Input() public hideViewportLabel: boolean = false;
  @Input() public useChip: boolean = false;

  protected readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;
  protected readonly viewportType: typeof ScanViewportType = ScanViewportType;

  constructor(private translateService: TranslateService) {}

  public getViewportLabel(): string {
    return `(${this.scanViewport?.width ?? '??'} x ${this.scanViewport?.height ?? '??'}px)`;
  }

  public get hasChipIcon(): boolean {
    return SharedCommonUtility.notNullish(this.chipIcon);
  }

  public get chipIcon(): Icons {
    if (SharedCommonUtility.isNullish(this.scanViewport?.viewportType)) {
      return null;
    }
    return ViewportIconsMap[this.scanViewport.viewportType] ?? null;
  }

  public get chipText(): string {
    if (SharedCommonUtility.isNullish(this.scanViewport?.viewportType)) {
      return null;
    }

    const labels: string[] = [this.translateService.instant(`scan_viewport_${this.scanViewport.viewportType}`)];
    if (!this.hideViewportLabel) {
      labels.push(this.getViewportLabel());
    }
    return labels.join(' ');
  }
}
